import { Currency } from './general';

export enum CollaboratorEnum {
  RESEARCH = 'RESEARCH',
  LAB = 'LAB',
  CLINIC = 'CLINIC',
  BUSINESS = 'BUSINESS',
}

export enum WorkflowTimeline {
  AMD = 'AMD',
  BME = 'BME',
  FFH = 'FFH',
  FMT = 'FMT',
  RESEARCH = 'RESEARCH',
  EXTERNAL = 'EXTERNAL',
}

export enum SampleType {
  STOOL = 'STOOL',
  URINE = 'URINE',
  SALIVA = 'SALIVA',
  RECTAL_SWAB = 'RECTAL_SWAB',
  SKIN = 'SKIN',
}

export enum CollectionMedium {
  ZYMO = 'ZYMO',
  ETHANOL = 'ETHANOL',
  RAW = 'RAW',
  FMT = 'FMT',
  GLYCEROL = 'GLYCEROL',
  TAPE = 'TAPE',
}

export enum ReportType {
  ASV = 'ASV',
  PDF = 'PDF',
  SCORE_TABLE = 'SCORE_TABLE',
  TAXA_TABLE = 'TAXA_TABLE',
  DISEASE_RISK = 'DISEASE_RISK',
  FASTQ = 'FASTQ',
}

export enum SpecialReportType {
  DADA2 = 'DADA2',
}

export enum ChannelsType {
  RESEARCH = 'RESEARCH',
  FMT = 'FMT',
  AMD = 'AMD',
  EXTERNAL = 'EXTERNAL',
  AMILI_ANALYTICS = 'AMILI_ANALYTICS',
  AMILI_HEALTH = 'AMILI_HEALTH',
  CONSUMER_HEALTH = 'CONSUMER_HEALTH',
}
export const ChannelsName: Record<string, string> = {
  [ChannelsType.RESEARCH]: 'Research',
  [ChannelsType.FMT]: 'FMT',
  [ChannelsType.AMD]: 'AMD',
  [ChannelsType.EXTERNAL]: 'External',
  [ChannelsType.AMILI_ANALYTICS]: 'Amili Analytics',
  [ChannelsType.AMILI_HEALTH]: 'Amili Health',
  [ChannelsType.CONSUMER_HEALTH]: 'Consumer Health',
};

//region External
export enum ExternalSampleType {
  STOOL = 'STOOL',
  DNA = 'DNA',
  FASTQ = 'FASTQ',
}
export enum ExternalCollectionMedium { //new
  ZYMO = 'ZYMO',
  ETHANOL = 'ETHANOL',
  RAW = 'RAW',
  FMT = 'FMT',
  GLYCEROL = 'GLYCEROL',
}

export enum ExternalSpeciesType {
  HUMAN = 'HUMAN',
  ANIMAL = 'ANIMAL',
  BACTERIA = 'BACTERIA',
}

export enum ExternalTissueNucleicAcidType {
  GENOMIC_DNA = 'GENOMIC_DNA',
}

export enum ExternalTissueOrgan {
  STOOL = 'STOOL',
  SALIVA = 'SALIVA',
}

// ddH2O/TE Buffer/RNA-free or DEPC treated water/pure ethanol
export enum ExternalElutionBuffer {
  DDH2O = 'DDH2O',
  TE_BUFFER = 'TE_BUFFER',
  RNA_FREE_OR_DEPC = 'RNA_FREE_OR_DEPC',
  PURE_ETHANOL = 'PURE_ETHANOL',
}

export enum ExternalPipeline {
  // V2_5 = 'V2_5',
  V3_0 = 'V3_0',
}

// None/ASV/Scores(Scoretable/Taxatable/Disease Risk)/PDF
export enum ExternalOutputType {
  ASV = 'ASV',
  PDF = 'PDF',
  SCORE_TABLE = 'SCORE_TABLE',
  TAXA_TABLE = 'TAXA_TABLE',
  DISEASE_RISK = 'DISEASE_RISK',
}

export enum ExternalPdfTemplate {
  A = 'A',
  B = 'B',
  C = 'C',
}

export enum ReportPrefix {
  KIT_ID = 'KIT_ID',
  EXTERNAL_ID = 'EXTERNAL_ID',
}

export enum PdfTemplateLanguage {
  AMILI_EN_DEFAULT = 'amili_en_default',
  AMILI_CN_DEFAULT = 'amili_chinese_default',
  AMILI_AR_DEFAULT = 'amili_arabic_default',
}

const defaultExternalValues = {
  externalCollectionMedium: undefined,
  noOfAutoGenSamples: undefined,
  externalTissueOrgan: undefined,
  externalSpeciesType: ExternalSpeciesType.HUMAN,
};
export const preFillExternalValues = {
  [ExternalSampleType.STOOL]: {
    ...defaultExternalValues,
    externalTissueOrgan: ExternalTissueOrgan.STOOL,
    externalCollectionMedium: [ExternalCollectionMedium.ZYMO],
    noOfAutoGenSamples: 4,
  },
  [ExternalSampleType.DNA]: {
    ...defaultExternalValues,
    externalTissueOrgan: ExternalTissueOrgan.STOOL,
  },
  [ExternalSampleType.FASTQ]: defaultExternalValues,
};

export enum SixteenSMLQueueEnum {
  NEW = 'new',
  RESEARCH = 'research',
  COMMERCIAL = 'commercial',
  QUARANTINE1 = 'quarantine-1',
  QUARANTINE2 = 'quarantine-2',
  QUARANTINE3 = 'quarantine-3',
  NEW_PRIORITY = 'new-priority',
  RESEARCH_PRIORITY = 'research-priority',
  COMMERCIAL_PRIORITY = 'commercial-priority',
  QUARANTINE_1_PRIORITY = 'quarantine-1-priority',
  QUARANTINE_2_PRIORITY = 'quarantine-2-priority',
  QUARANTINE_3_PRIORITY = 'quarantine-3-priority',
}

export enum ShotgunQueue {
  NEW = 'new',
  RESEARCH = 'research',
  QUARANTINE = 'quarantine',
}

export enum ProjectOwnershipEnum {
  FULLY_OWNED = 'Fully owned',
  AUTHORIZED = 'Authorized',
  UNAUTHORIZED = 'Unauthorized',
}

export enum ProjectPolicyEnum {
  PUBLIC = 'Public',
  CONFIDENTIAL = 'Confidential',
  INTERNAL = 'Internal',
  CLIENT_SPECIFIC = 'Client-specific',
}

export enum IsExpiredOptions {
  NONE = 'None',
  EXPIRED = 'Expired',
}

export enum PdfGeneratorVersion {
  V5 = 'v5',
  V6 = 'v6',
}

export const DEFAULT_TEMPLATE_BY_PDF_VERSION = {
  [PdfGeneratorVersion.V5]: 'Standard',
  [PdfGeneratorVersion.V6]: 'Standard (v6)',
};
export const DEFAULT_FOOD_SET = 'Singapore V5';

export enum OutputLocation {
  REPORT_MODULE = 'report_module',
}

export enum MetaTagKey {
  SCORE_PATH = 'score_path',
}

export enum ProjectClientPriority {
  OBSERVE = 'OBSERVE',
  GAIN = 'GAIN',
  MAINTAIN = 'MAINTAIN',
  BUILD = 'BUILD',
  DEFEND = 'DEFEND',
}

export enum ProjectCountry {
  HONGKONG = 'HONGKONG',
  SINGAPORE = 'SINGAPORE',
  THAILAND = 'THAILAND',
  MALAYSIA = 'MALAYSIA',
  VIETNAM = 'VIETNAM',
  SAUDI = 'SAUDI',
  INDONESIA = 'INDONESIA',
  PHILIPPINES = 'PHILIPPINES',
}

export const PROJECT_COUNTRY_TO_CURRENCY: Record<ProjectCountry, Currency> = {
  [ProjectCountry.HONGKONG]: Currency.HKD,
  [ProjectCountry.SINGAPORE]: Currency.SGD,
  [ProjectCountry.THAILAND]: Currency.THB,
  [ProjectCountry.MALAYSIA]: Currency.MYR,
  [ProjectCountry.VIETNAM]: Currency.VND,
  [ProjectCountry.SAUDI]: Currency.SAR,
  [ProjectCountry.INDONESIA]: Currency.IDR,
  [ProjectCountry.PHILIPPINES]: Currency.PHP,
};
